export const getAvailableEdokForms = (state) => state.edok.availableForms || {};
